module.exports = __webpack_public_path__ + "img/jcyj_index4.2d664fc3.jpg";